import { useEffect, useState } from "react"
import useAuth from "../../../hooks/useAuthContext"
import axiosInstance from "../../../hooks/axiosInstance"
import { toast } from "react-toastify"
import { useParams } from "react-router-dom"

export default function AssociationDashboardPage() {
    const {userData} = useAuth()
    const {associationId} = useParams()

    const [loading, setLoading] = useState(false)
    const [analytics, setAnalytics] = useState([])

    const fetchAssociationAnalytics = () => {
        setLoading(true);
        axiosInstance
        .get(`/user/dashboard/analytics/${associationId}`)
        .then((response) => {
            setAnalytics(response.data.data.association_analytics);
        })
        .catch((err) => {
            toast.error("An error occured. Please, try again");
        })
        .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchAssociationAnalytics()
    }, [])


    return (
        <>
            <div className="row">
                <div className="col">

                    <div className="h-100">
                        <div className="row mb-3 pb-1">
                            <div className="col-12">
                                <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                                    <div className="flex-grow-1">
                                        <h4 className="fs-16 mb-1">Welcome, <span className="text-info font-weight-bold">{userData.userInfo?.last_name}</span></h4>
                                        <p className="text-muted mb-0">Here's what's happening with your association
                                            today.</p>
                                    </div>
                                </div>
                                {/* <!-- end card header --> */}
                            </div>
                            {/* <!--end col--> */}
                        </div>
                        {/* <!--end row--> */}

                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card crm-widget">
                                    <div className="card-body p-0">
                                        <div className="row row-cols-xxl-5 row-cols-md-3 row-cols-1 g-0">
                                            <div className="col">
                                                <div className="py-4 px-3">
                                                    <h5 className="text-muted text-uppercase fs-13">Members <i className="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i></h5>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shrink-0">
                                                            <i className="ri-group-line display-6 text-muted"></i>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <h2 className="mb-0"><span className="counter-value" data-target="5">{analytics?.total_members}</span></h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="mt-3 mt-md-0 py-4 px-3">
                                                    <h5 className="text-muted text-uppercase fs-13">Total Applications <i className="ri-arrow-down-circle-line text-warning fs-18 float-end align-middle"></i></h5>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shrink-0">
                                                            <i className="ri-time-line display-6 text-muted"></i>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <h2 className="mb-0"><span className="counter-value" data-target={analytics?.total_applications}>{analytics?.total_applications}</span></h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- end col --> */}
                                            <div className="col">
                                                <div className="mt-3 mt-md-0 py-4 px-3">
                                                    <h5 className="text-muted text-uppercase fs-13">Outstanding Dues <i className="ri-arrow-up-circle-line text-warning fs-18 float-end align-middle"></i></h5>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shrink-0">
                                                            <i className="ri-exchange-dollar-line display-6 text-muted"></i>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            {/* <h2 className="mb-0">₦<span className="counter-value" data-target="23.5">0</span>k</h2> */}
                                                            <h2 className="mb-0">-</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- end col --> */}
                                            <div className="col">
                                                <div className="mt-3 mt-md-0 py-4 px-3">
                                                    <h5 className="text-muted text-uppercase fs-13">Next Due Date <i className="ri-arrow-down-circle-line text-warning fs-18 float-end align-middle"></i></h5>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shrink-0">
                                                            <i className="ri-calendar-todo-line display-6 text-muted"></i>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            {/* <h2 className="mb-0"><span className="counter-value">10/11/2023</span></h2> */}
                                                            <h2 className="mb-0">-</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- end col --> */}
                                            <div className="col">
                                                <div className="mt-3 mt-lg-0 py-4 px-3">
                                                    <h5 className="text-muted text-uppercase fs-13">Next Meeting Date <i className="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i></h5>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shrink-0">
                                                            <i className="ri-calendar-event-line display-6 text-muted"></i>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            {/* <h2 className="mb-0"><span className="counter-value">10/05/2024</span></h2> */}
                                                            <h2 className="mb-0">-</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- end col --> */}
                                            <div className="col">
                                                {/* <div className="mt-3 mt-lg-0 py-4 px-3">
                                                    <h5 className="text-muted text-uppercase fs-13">Open Associations <i className="ri-arrow-down-circle-line text-danger fs-18 float-end align-middle"></i></h5>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shrink-0">
                                                            <i className="ri-service-line display-6 text-muted"></i>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <h2 className="mb-0"><span className="counter-value" data-target="1050">0</span></h2>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>{/* <!-- end col --> */}
                                        </div> {/* <!-- end row --> */}
                                    </div>{/* <!-- end card body --> */}
                                </div>{/* <!-- end card --> */}
                            </div>
                            {/* <!-- end col --> */}
                        </div>
                        {/* <!-- end row--> */}

                        <div className="row">
                            <div className="col-xl-8">
                                <div className="card card-height-100">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">News Feed</h4>
                                        <div>
                                            <button type="button" className="btn btn-soft-primary btn-sm">
                                                View all
                                            </button>
                                        </div>
                                    </div>{/* <!-- end card-header --> */}

                                    <div className="card-body">
                                        {1 == 0 ?
                                            <>
                                                <div className="d-flex align-middle">
                                                    <div className="flex-shrink-0">
                                                        <img src="/assets/images/small/img-1.jpg" className="rounded img-fluid" style={{height: "60px"}} alt="" />
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1 lh-base"><a href="#" className="text-reset">One stop shop destination on all the latest news in crypto currencies</a></h6>
                                                        <p className="text-muted fs-12 mb-0">Dec 12, 2021 <i className="mdi mdi-circle-medium align-middle mx-1"></i>09:22 AM</p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="d-flex mt-4">
                                                    <div className="flex-shrink-0">
                                                        <img src="/assets/images/small/img-2.jpg" className="rounded img-fluid" style={{height: "60px"}} alt="" />
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1 lh-base"><a href="#" className="text-reset">Coin Journal is dedicated to delivering stories on the latest crypto</a></h6>
                                                        <p className="text-muted fs-12 mb-0">Dec 03, 2021 <i className="mdi mdi-circle-medium align-middle mx-1"></i>12:09 PM</p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="d-flex mt-4">
                                                    <div className="flex-shrink-0">
                                                        <img src="/assets/images/small/img-3.jpg" className="rounded img-fluid" style={{height: "60px"}} alt="" />
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1 lh-base"><a href="#" className="text-reset">The bitcoin-holding U.S. senator is trying to “fully integrate” crypto </a></h6>
                                                        <p className="text-muted fs-12 mb-0">Nov 22, 2021 <i className="mdi mdi-circle-medium align-middle mx-1"></i>11:47 AM</p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="d-flex mt-4">
                                                    <div className="flex-shrink-0">
                                                        <img src="/assets/images/small/img-6.jpg" className="rounded img-fluid" style={{height: "60px"}} alt="" />
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1 lh-base"><a href="#" className="text-reset">Cryptocurrency price like Bitcoin, Dash, Dogecoin, Ripple and Litecoin</a></h6>
                                                        <p className="text-muted fs-12 mb-0">Nov 18, 2021 <i className="mdi mdi-circle-medium align-middle mx-1"></i>06:13 PM</p>
                                                    </div>
                                                </div>{/* <!-- end --> */}

                                                <div className="mt-3 text-center">
                                                    <a href="javascript:void(0);" className="text-muted text-decoration-underline">View all News</a>
                                                </div>
                                            </>
                                            :
                                            <div className="noresult">
                                                <div className="text-center">
                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                                    <h5 className="mt-2">Sorry! No News Found</h5>
                                                    {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {/* <!-- end card body --> */}
                                </div>
                                {/* <!-- end card --> */}
                            </div>
                            {/* <!-- end col --> */}

                            <div className="col-xxl-4">
                                <div className="card">
                                    <div className="card-header border-0">
                                        <h4 className="card-title mb-0">Upcoming Events</h4>
                                    </div>{/* <!-- end cardheader --> */}
                                    <div className="card-body pt-0">
                                        {1 == 0 ?
                                            <>
                                                {/* <h6 className="text-uppercase fw-semibold mt-4 mb-3 text-muted">Events:</h6> */}
                                                <div className="mini-stats-wid d-flex align-items-center mt-3">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                                            09
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1">Development planning</h6>
                                                        <p className="text-muted mb-0">September, 2023 </p>
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <p className="text-muted mb-0">9:20 <span className="text-uppercase">am</span></p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="mini-stats-wid d-flex align-items-center mt-3">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                                            12
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1">Design new UI and check sales</h6>
                                                        <p className="text-muted mb-0">January, 2024</p>
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <p className="text-muted mb-0">11:30 <span className="text-uppercase">am</span></p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="mini-stats-wid d-flex align-items-center mt-3">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                                            25
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1">Weekly catch-up </h6>
                                                        <p className="text-muted mb-0">February, 2024</p>
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <p className="text-muted mb-0">02:00 <span className="text-uppercase">pm</span></p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="mini-stats-wid d-flex align-items-center mt-3">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                                            27
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1">James Bangs (Client) Meeting</h6>
                                                        <p className="text-muted mb-0">August, 2023</p>
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <p className="text-muted mb-0">03:45 <span className="text-uppercase">pm</span></p>
                                                    </div>
                                                </div>{/* <!-- end --> */}

                                                <div className="mt-3 text-center">
                                                    <a href="javascript:void(0);" className="text-muted text-decoration-underline">View all Events</a>
                                                </div>
                                            </>
                                            :
                                            <div className="noresult">
                                                <div className="text-center">
                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                                    <h5 className="mt-2">Sorry! No Events Found</h5>
                                                    {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                                                </div>
                                            </div>
                                        }

                                    </div>{/* <!-- end cardbody --> */}
                                </div>{/* <!-- end card --> */}
                            </div>
                        </div>
                        
                        {/* <!-- end row--> */}

                    </div>
                    {/* <!-- end .h-100--> */}

                </div>
                {/* <!-- end col --> */}
            </div>
        </>
    )
}